export const oneDay = 1000 * 60 * 60 * 24;
